var actions = {
	next: "Næste",
	confirm: "Bekræft",
	"continue": "Fortsæt"
};
var errors = {
	unknown: "Der opstod en uventet fejl",
	contactSupport: "Der opstod en fejl. Kontakt venligst support.",
	tryAgain: "Der opstod en fejl. Prøv igen.",
	submit: "Der var en fejl ved din indsendelse."
};
var brands = {
	apple: "Apple",
	facebook: "Facebook",
	google: "Google",
	paypal: "PayPal",
	picarto: "Picarto",
	tiktok: "TikTok",
	trovo: "Trovo",
	twitch: "Twitch",
	youtube: "YouTube",
	twitter: "X (Twitter)",
	linkedin: "LinkedIn",
	streamlabs: "Streamlabs",
	mevo: "Mevo",
	typestudio: "TypeStudio"
};
var loginButton = {
	loginWith: "Log på med {name}",
	signupWith: "Tilmeld dig med {name}"
};
var alreadyHaveAccount = {
	company: "Har du allerede en {company}-konto?",
	text: "Har du allerede et Streamlabs ID?",
	link: "Log på"
};
var noAccount = {
	text: "Har du ikke en konto endnu?",
	link: "Tilmeld dig"
};
var validation = {
	email: {
		invalid: "Indtast en gyldig e-mailadresse"
	},
	password: {
		required: "Adgangskode er obligatorisk",
		min: "Adgangskoden skal være på minimum 9 tegn",
		number: "Adgangskoden skal indeholde et tal",
		upper: "Adgangskoden skal indeholde et stort bogstav",
		special: "Adgangskoden skal indeholde et specialtegn"
	},
	username: {
		invalid: "Navnet skal være på mindst 5 tegn"
	},
	code: {
		minmax: "Koden skal være mellem 6 og 10 tegn"
	}
};
var poweredBy = "Drevet af <company>Streamlabs</company>";
var card = {
	"404": {
		title: "Virksomheden blev ikke fundet!",
		desc: "Prøv igen senere, eller kontakt support."
	},
	company: {
		logoAlt: "{company}-logo"
	}
};
var checkTfaForm = {
	tfaCodePlaceholder: "6-cifret godkendelseskode/8-cifret backup-kode",
	successText: "Gennemført! Sender videre ...",
	remember: "Husk denne enhed i 30 dage"
};
var createTfa = {
	scan: {
		title: "Aktivér tofaktorgodkendelse",
		lead: "Klik/kopiér eller scan koden nedenfor ved hjælp af din foretrukne godkendelsesapp. Vi anbefaler, at du bruger en app som <app0 />, <app1 /> eller <app2 /> for at gemme dine koder sikkert.",
		copied: "Kopieret!",
		instructions: "Eller indtast denne kode manuelt ind i din godkendelsesapp.",
		copy: "Kopiér kode",
		proceed: "Bekræftelse"
	},
	confirm: {
		title: "Bekræft din tofaktorgodkendelse",
		lead: "Indsend en genereret 2F-kode. nedenfor, og aktivér to-faktor-godkendelse.",
		label: "To-faktor-godkendelseskode (6 cifre)",
		verify: "Verificer kode",
		next: "Gennemført! Næste trin"
	},
	save: {
		title: "Gem dine gendannelseskoder",
		lead: "Gem dine gendannelseskoder nedenfor i tilfælde af, at du mister adgang til din to-faktor-godkendelseskode. Når du lukker denne modal, vil disse koder ikke være tilgængelige mere.",
		label: "Gendannelseskoder",
		download: "Download gendannelseskoder",
		copied: "Koder er kopieret!",
		finished: "Udført"
	}
};
var emailLoginForm = {
	buttonText: "Log på",
	emailPlaceholder: "E-mailadresse",
	passwordPlaceholder: "Adgangskode"
};
var emailSignupForm = {
	buttonText: "Tilmeld dig",
	emailPlaceholder: "Opret en e-mailadresse",
	passwordPlaceholder: "Opret en adgangskode",
	usernamePlaceholder: "Dit navn",
	ageLabel: "Fødselsdato",
	agePlaceholder: "MM/DD/ÅÅÅÅ",
	agreeText: "Jeg accepterer Streamlabs‹ <terms>Servicevilkår</terms> og <privacy>Fortrolighedspolitik</privacy>.",
	agreeError: "Accepter Streamlabs‹ vilkår og betingelser"
};
var ageInput = {
	invalidDate: "Indtast en gyldig fødselsdato",
	futureDate: "Fødselsdatoen skal være i fortiden",
	minDate: "Datoer før år {year} er ikke tilladt",
	minAge_one: "Du skal være {years} år eller ældre for at bruge Streamlabs.",
	minAge_two: "Du skal være {years} år eller ældre for at bruge Streamlabs.",
	minAge_other: "Du skal være {years} år eller ældre for at bruge Streamlabs."
};
var forgotPasswordForm = {
	emailPlaceholder: "E-mailadresse",
	back: "Tilbage til login",
	successText: "Gennemført! Vi har sendt dig en kode til nulstilling af adgangskode",
	buttonText: "Anmod om nulstilling af e-mailadresse",
	create: {
		successText: "Gennemført! Vi har sendt dig en bekræftelseskode for at komme i gang!",
		buttonText: "Anmod om bekræftelseskode"
	},
	errors: {
		notFound: "Ingen konto fundet med denne e-mailadresse"
	}
};
var forgotPasswordCard = {
	forgot: {
	},
	title: "Har du glemt din adgangskode?",
	lead: "Hvis du har brug for at nulstille din adgangskode, skal du indtaste din e-mailadresse nedenfor, hvorefter vi sender en e-mail til dig for at påbegynde processen.",
	resetTitle: "Nulstil din adgangskode",
	resetLead: "Du bør have modtaget en kode via e-mail. Gennemfør formlen til nulstilling af din adgangskode.",
	create: {
		title: "Skift din adgangskode",
		lead: "Tillykke med oprettelsen af dit Streamlabs ID! Et trin mere, og du vil være i stand til at logge ind på tværs af hele Streamlabs!",
		resetTitle: "Vælg en adgangskode",
		resetLead: "Du bør have modtaget en kode via e-mail. Brug den, og udfyld formularen for at angive din adgangskode."
	},
	successText: "Gennemført! Sender videre ...",
	signInTitle: "Har du allerede en konto?",
	signInBtn: "Log på"
};
var checkTfaCard = {
	title: "Tjek af tofaktorgodkendelse",
	lead: "Indtast en to-faktor-godkendelseskode nedenfor at fortsætte.",
	successText: "2F-godkendelse bekræftet!",
	back: "Tilbage"
};
var verifyEmailCard = {
	title: "Bekræft din e-mailadresse",
	lead: "Tjek din e-mail for en 8-cifret kode fra Streamlabs, og indtast den nedenfor.",
	back: "Tilbage",
	successText: "E-mailadresse bekræftet!"
};
var upgradeCard = {
	confirm: {
		title: "Bekræft tilknytning til {company}",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Fremover vil du kunne logge ind på {company} med den e-mailadresse og adgangskode, du har valgt.",
			"Du kan få adgang til alle andre produkter fra Streamlabs med dit ID og tilknytte eventuelle andre konti, du måtte have.",
			"Din {company}-konto vil ikke blive berørt af denne ændring."
		],
		button: "Bekræft",
		cancel: "Annuller",
		switchAccount: "Skift konto",
		success: "Tilknytter ..."
	},
	confirmed: {
		title: "Gennemført!",
		subtitle: "Dit Streamlabs ID er blevet oprettet, og {company}-kontoen er nu tilknyttet.",
		text: "Du kan bruge dit Streamlabs ID til alle Streamlabs-produkter. Hvis du har eksisterende konti, kan du knytte dem til dette ID i de relevante apps.",
		button: "Luk"
	},
	error: {
		user: "Brugeridentifikation mislykkedes. Prøv at logge ind igen, eller kontakt support."
	}
};
var confirmCard = {
	confirm: {
		title: "Bekræft tilknytning til {company}",
		subtitle: "Der findes allerede en konto med denne e-mailadresse. Vil du knytte denne konto til dit Streamlabs ID?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Du vil kunne logge ind på {company} med den e-mailadresse og adgangskode, du har valgt via Streamlabs ID.",
			"Du kan få adgang til alle andre produkter fra Streamlabs med dit ID og tilknytte eventuelle andre konti, du måtte have.",
			"Din firmakonto bliver ikke berørt af denne ændring."
		],
		button: "Bekræft",
		cancel: "Annuller",
		switchAccount: "Skift konto",
		success: "Tilknytter ..."
	},
	confirmed: {
		title: "Gennemført!",
		subtitle: "Dit Streamlabs ID er blevet oprettet, og {company}-kontoen er nu tilknyttet.",
		text: "Du kan bruge dit Streamlabs ID til alle Streamlabs-produkter. Hvis du har eksisterende konti, kan du knytte dem til dette ID i de relevante apps.",
		button: "Luk"
	},
	error: {
		user: "Brugeridentiteten kunne ikke bekræftes. Prøv at logge ind igen, eller kontakt support."
	}
};
var upgradeConfirmCard = {
	confirm: {
		title: " Der er allerede knyttet en {company}-konto til dit ID",
		subtitle: "Vil du fjerne tilknytningen til den nuværende konto og tilknytte denne Streamlabs-konto i stedet?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Du vil kunne kunne logge ind på Streamlabs med den e-mailadresse og adgangskode, du har valgt til Streamlabs ID.",
			"Du kan få adgang til alle andre produkter fra Streamlabs med dit ID og tilknytte eventuelle andre konti, du måtte have.",
			"Din Streamlabs-konto bliver ikke berørt af denne ændring."
		],
		button: "Bekræft",
		cancel: "Annuller",
		switchAccount: "Skift konto",
		success: "Tilknytter ...",
		agreeLabel: "Jeg bekræfter at have forstået, at ved at oprette denne tilknytning mister I adgang til den {company}-konto, der er knyttet til Streamlabs ID i øjeblikket."
	},
	confirmed: {
		title: "Gennemført!",
		subtitle: "Dit Streamlabs ID er blevet oprettet, og {company}-kontoen er nu tilknyttet.",
		text: "Du kan bruge dit Streamlabs ID til alle Streamlabs-produkter. Hvis du har eksisterende konti, kan du knytte dem til dette ID i de relevante apps.",
		button: "Luk"
	},
	error: {
		user: "Brugeridentiteten kunne ikke bekræftes. Prøv at logge ind igen, eller kontakt support."
	}
};
var loginCard = {
	title: "Log på",
	lead: "Log på <company>{company}</company> med <id>Streamlabs ID</id>",
	accountExists: "Det ser ud som om, du har et <b>Streamlabs ID</b>. Prøv at logge på med din e-mailadresse.",
	forgotPassword: "Har du glemt din adgangskode?",
	successText: "Gennemført! Sender videre ...",
	signInTitle: "Log på via en platform"
};
var loginSourcesCard = {
	title: "Log på",
	lead: "Log på med e-mailadresse/adgangskode",
	withSlId: "Log på med Streamlabs ID",
	noAccountMessage: "Vi kan ikke se en konto tilknyttet denne login-metode. Prøv en anden login-metode eller <signup>Tilmeld dig</signup>, hvis du ikke har gjort det endnu.",
	accountExistsMessage: "Din Twitch-e-mailadresse er allerede tilknyttet en Streamlabs-e-mailadresse. Prøv at logge på med din Streamlabs-e-mail og -adgangskode."
};
var resetPasswordForm = {
	emailPlaceholder: "E-mailadresse",
	codePlaceholder: "6-8-cifret email-kode",
	tfaCodePlaceholder: "2F-godkendelseskode",
	newPasswordPlaceholder: "Ny adgangskode",
	tfaError: "Nulstillingskoden skal være mellem 6 og 10 tegn",
	next: "Har du modtaget koden?",
	back: "Tilbage til Glemt adgangskode",
	buttonText: "Skift adgangskode",
	successText: "Nulstilling af adgangskode gennemført",
	create: {
		back: "Tilbage til start",
		buttonText: "Indstil adgangskode",
		successText: "Adgangskoden blev angivet"
	}
};
var changePasswordForm = {
	currentPasswordPlaceholder: "Nuværende adgangskode",
	newPasswordPlaceholder: "Ny adgangskode",
	newPasswordConfirmationPlaceholder: "Bekræft ny adgangskode",
	buttonText: "Skift adgangskode",
	successText: "Adgangskode opdateret",
	newPasswordConfirmationError: "Nye adgangskoder er ikke ens",
	back: "Tilbage til dashboard"
};
var changePasswordCard = {
	title: "Skift din adgangskode",
	lead: "Indtast din nuværende adgangskode sammen med den nye adgangskode nedenfor.",
	successText: "Adgangskode opdateret"
};
var removeTfaForm = {
	tfaCodePlaceholder: "6-cifret godkendelseskode/8-cifret backup-kode",
	successText: "2F-godkendelse fjernet",
	removeBtn: "Bekræft og fjern"
};
var removeTfaCard = {
	title: "Fjern tofaktorgodkendelse",
	lead: "Indtast en 2F-godkendelseskode nedenfor for at fjerne to-faktor-godkendelse fra din konto.",
	successText: "2F-godkendelse fjernet",
	back: "Tilbage til dashboard"
};
var verifyEmailForm = {
	codePlaceholder: "8-cifret kode fra email",
	tfaCodePlaceholder: "2F-godkendelseskode",
	emailPlaceholder: "E-mailadresse",
	buttonText: "Bekræft e-mailadresse",
	successText: "E-mailadresse bekræftet!",
	requestBtn: "Anmod om ny kode",
	requestingBtn: "Anmoder ...",
	requestSuccess: "En kode er blevet sendt til din e-mailadresse",
	requestAgain: "Anmod igen om {seconds}er",
	tfaError: "Nulstillingskoden skal være mellem 6 og 10 tegn",
	back: "Tilbage"
};
var signupCard = {
	title: "Tilmeld dig",
	lead: "Opret en <id>Streamlabs ID</id>-konto for at bruge <company>{company}</company>",
	successText: "Gennemført! Sender videre ..."
};
var signupSourcesCard = {
	title: "Tilmeld dig",
	lead: "Opret en <id>Streamlabs ID</id>-konto for at bruge <company>{company}</company>",
	withSlId: "Opret et Streamlabs ID"
};
var connectCard = {
	connect: {
		title: "Vælg en konto",
		lead: "for at fortsætte til <b>{company}</b>",
		authorize: "Godkend",
		authorizeSuccess: "Gennemført!",
		cancel: "Annuller",
		disclaimer: {
			streamlabs: "Hvis du fortsætter, deles dit Streamlabs-ID (navn, e-mailadresse, sprogindstillinger og profilbillede) med <b>{company}</b>. Ved at godkende en konto hos <b>{company}</b>, accepterer du hermed <b>{company}</b>'s <privacy>fortrolighedspolitik</privacy> og <terms>servicevilkår</terms>.",
			"default": "Hvis du vil fortsætte, vil Streamlabs dele dit navn, din e-mailadresse, sprogpræference og dit profilbillede med <b>{company}</b>. Ved at godkende en konto hos <b>{company}</b>, accepterer du hermed <b>{company}</b>'s <privacy>fortrolighedspolitik</privacy> og <terms>servicevilkår</terms>."
		},
		emailRequired: "E-mailbekræftelse er påkrævet, inden du kan fortsætte",
		tfaRequired: "To-faktor-godkendelse kræves for at du kan fortsætte"
	},
	login: {
		title: "Log på {company}",
		lead: "Du skal være logget på for at kunne tilknytte konti",
		loginBtn: "Fortsæt for at logge på"
	},
	error: {
		title: "Log på {company}",
		lead: "Din anmodning kunne ikke godkendes denne gang.",
		verifyEmail: "Bekræft e-mailadresse",
		verify2fa: "Bekræft 2FA"
	},
	"switch": {
		btn: "Brug en anden konto"
	}
};
var appsDropdown = {
	label: "Streamlabs produkter og apps",
	viewMore: "Udvid",
	viewLess: "Minimer"
};
var platformButtons = {
	loginWithPlatform: "Log på via en platform",
	signUpWithPlatform: "Tilmeld dig via en platform",
	signUpLead: "Vi understøtter livestreaming til mange flere platforme, og dette er bare tilmeldingsmulighederne."
};
var ultraCheckoutCard = {
	title: "Opgrader dine livestreams, branding, redigering og meget mere med <b>Streamlabs Ultra</b>",
	badge: "Inkluderer <b>{planName}</b>",
	totalValue: "{price, currency} værdi",
	price: {
		month: "{price, currency}/mdr",
		year: "{price, currency}/år"
	},
	description: {
		month: "Få adgang til premium-funktioner i hele pakken, herunder <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, og meget mere, til én overkommelig pris.",
		year: "Få adgang til premium-funktioner i hele pakken, herunder <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, og meget mere, til én overkommelig pris."
	},
	seeIncluded: "Læs mere",
	buyNow: "Opgrader"
};
var ultraCheckoutBanner = {
	title: "Opgrader dine livestreams, branding, redigering og meget mere med <b>Streamlabs Ultra</b>",
	badge: "Inkluderer <b>{planName}</b>",
	totalValue: "{price, currency} værdi",
	price: {
		month: "{price, currency}/mdr",
		year: "{price, currency}/år"
	},
	description: {
		month: "Få adgang til premium-funktioner i hele pakken, herunder <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, og meget mere, til én overkommelig pris. <link />",
		year: "Få adgang til premium-funktioner i hele pakken, herunder <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, og meget mere, til én overkommelig pris. <link />"
	},
	seeIncluded: "Læs mere",
	buyNow: "Opgrader"
};
var connect = {
	waitMessage: "Sammenlægning af data. Luk ikke dette vindue."
};
var verifyPasswordCard = {
	success: "Adgangskode bekræftet",
	title: "Autentificer igen for at bekræfte",
	lead: "Log ind med din eksisterende e-mail og adgangskode for at fortsætte med at opdatere dit Streamlabs ID.",
	buttonText: "Næste"
};
var emailChangeForm = {
	agreeError: "Bekræft, at du forstår denne handling",
	buttonText: "Næste",
	emailPlaceholder: "Ny e-mailadresse",
	agreeText: "Jeg forstår, at når mit Streamlabs ID er bekræftet, vil det ændre sig på tværs af alle Streamlabs produkter, det er forbundet til."
};
var verifyNewEmailCard = {
	title: "Skift dit Streamlabs ID",
	lead: "Angiv en ny e-mail, der skal bruges som dit Streamlabs ID. Vi sender en 6-8-cifret bekræftelseskode til denne adresse.",
	successText: "Ny e-mailadresse tilgængelig"
};
var verifyNewEmailOwnershipCard = {
	title: "Bekræft dit opdaterede Streamlabs ID",
	lead: "Tjek din e-mail for en 8-cifret kode fra Streamlabs, og indtast den nedenfor.",
	buttonText: "Bekræft",
	back: "Tilbage",
	codePlaceholder: "8-cifret kode fra email",
	successText: "E-mailadresse bekræftet"
};
var verifyTfaCard = {
	title: "Tjek af tofaktorgodkendelse",
	lead: "Indtast den 6-cifrede bekræftelseskode fra din godkendelsesapp.",
	codePlaceholder: "6-cifret kode",
	buttonText: "Bekræft",
	successText: "2-faktor autentificering bekræftet",
	back: "Tilbage"
};
var ageGateForm = {
	ageLabel: "Fødselsdato",
	agePlaceholder: "MM/DD/ÅÅÅÅ"
};
var ageGateCard = {
	title: "Færdiggør kontoopsætning",
	lead: {
		years: "Du skal være {years} eller ældre for at oprette en konto. <br />Indtast din fødselsdato for at afslutte opsætningen.",
		noYears: "Du skal oplyse din fødselsdato for at oprette en konto. <br />Indtast den for at afslutte opsætningen."
	},
	successText: "Tillykke! Kontoopsætning fuldført."
};
var daDK = {
	actions: actions,
	errors: errors,
	brands: brands,
	loginButton: loginButton,
	alreadyHaveAccount: alreadyHaveAccount,
	noAccount: noAccount,
	validation: validation,
	poweredBy: poweredBy,
	card: card,
	checkTfaForm: checkTfaForm,
	createTfa: createTfa,
	emailLoginForm: emailLoginForm,
	emailSignupForm: emailSignupForm,
	ageInput: ageInput,
	forgotPasswordForm: forgotPasswordForm,
	forgotPasswordCard: forgotPasswordCard,
	checkTfaCard: checkTfaCard,
	verifyEmailCard: verifyEmailCard,
	upgradeCard: upgradeCard,
	confirmCard: confirmCard,
	upgradeConfirmCard: upgradeConfirmCard,
	loginCard: loginCard,
	loginSourcesCard: loginSourcesCard,
	resetPasswordForm: resetPasswordForm,
	changePasswordForm: changePasswordForm,
	changePasswordCard: changePasswordCard,
	removeTfaForm: removeTfaForm,
	removeTfaCard: removeTfaCard,
	verifyEmailForm: verifyEmailForm,
	signupCard: signupCard,
	signupSourcesCard: signupSourcesCard,
	connectCard: connectCard,
	appsDropdown: appsDropdown,
	platformButtons: platformButtons,
	ultraCheckoutCard: ultraCheckoutCard,
	ultraCheckoutBanner: ultraCheckoutBanner,
	connect: connect,
	verifyPasswordCard: verifyPasswordCard,
	emailChangeForm: emailChangeForm,
	verifyNewEmailCard: verifyNewEmailCard,
	verifyNewEmailOwnershipCard: verifyNewEmailOwnershipCard,
	verifyTfaCard: verifyTfaCard,
	ageGateForm: ageGateForm,
	ageGateCard: ageGateCard
};

export { daDK as d };
//# sourceMappingURL=da-DK.es.js.map
